export default __webpack_public_path__ + "static/media/mobile-phone.5a000310.png";